export const EngineerIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <title>{"study-maths-brain"}</title>
      <path
        d="M6.851,23.5V21.023H5.932a2.477,2.477,0,0,1-2.478-2.478V16.067H1.343a.5.5,0,0,1-.474-.653c1.1-3.414,2-6.989,4.286-9.081,0,0,2.582-2.559,7.8-1.516s5.46,7.739,5.46,7.739a8.036,8.036,0,0,1-3.3,6.494V23.5Z"
        fill="#c4f0eb"
      />
      <path
        d="M10.406,7.61a12.3,12.3,0,0,1,7.62,2.639c-.551-2.042-1.877-4.793-5.07-5.432-5.219-1.043-7.8,1.516-7.8,1.516a11.057,11.057,0,0,0-2.61,4.1A12.318,12.318,0,0,1,10.406,7.61Z"
        fill="#c4f0eb"
      />
      <line
        x1={17.656}
        y1={0.501}
        x2={17.656}
        y2={4.501}
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1={19.656}
        y1={2.501}
        x2={15.656}
        y2={2.501}
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1={20.327}
        y1={6.001}
        x2={23.156}
        y2={8.83}
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1={23.156}
        y1={6.001}
        x2={20.327}
        y2={8.83}
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1={15.156}
        y1={8.497}
        x2={11.156}
        y2={8.497}
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.156,6.247a.25.25,0,0,0-.25.25"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.406,6.5a.25.25,0,0,0-.25-.25"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.156,6.747a.25.25,0,0,0,.25-.25"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.906,6.5a.25.25,0,0,0,.25.25"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.156,10.247a.25.25,0,0,0-.25.25"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.406,10.5a.25.25,0,0,0-.25-.25"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.156,10.747a.25.25,0,0,0,.25-.25"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.906,10.5a.25.25,0,0,0,.25.25"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <polyline
        points="7.656 2.001 8.656 3.501 9.656 0.501 13.156 0.501"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.851,23.5V21.023H5.932a2.477,2.477,0,0,1-2.478-2.478V16.067H1.343a.5.5,0,0,1-.474-.653c1.1-3.414,2-6.989,4.286-9.081"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.416,12.556a8.036,8.036,0,0,1-3.3,6.494V23.5"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
